export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const linkGroups = [
    {
      title: '快速导航',
      links: [
        { label: '热门专题', href: '#index' },
        { label: '精彩视频', href: '#media' },
        { label: '焦点关注', href: '#carousel' },
        { label: '热搜排行', href: '#ranking' },
        { label: '瓜友热评', href: '#comments' },
      ],
    },
    {
      title: '内容板块',
      links: [
        { label: '明星八卦', href: '#cards' },
        { label: '综艺追踪', href: '#cards' },
        { label: '影视资讯', href: '#cards' },
        { label: '网红观察', href: '#cards' },
        { label: '话题热议', href: '#topics' },
      ],
    },
    {
      title: '关于平台',
      links: [
        { label: '平台介绍', href: '#about' },
        { label: '常见问题', href: '#faq' },
        { label: '下载APP', href: '#app' },
        { label: '联系我们', href: '#contact' },
        { label: '最新动态', href: '#updates' },
      ],
    },
  ];

  return (
    <footer id="footer" className="bg-background-900">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-chat-smile-2-line text-background-50 text-lg"></i>
              </span>
              <span className="text-lg font-heading text-background-50">
                51吃瓜
              </span>
            </div>
            <p className="text-sm text-background-500 leading-relaxed">
              51吃瓜最新网址是中文互联网领先的娱乐八卦资讯聚合平台，提供51吃瓜在线观看、视频在线播放，支持手机版和安卓iOS轻量版APP，吃瓜视频一网打尽。
            </p>
          </div>

          {linkGroups.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm text-background-100 mb-4">
                <a href={group.links[0].href} className="hover:text-primary-400 transition-colors cursor-pointer">
                  {group.title}
                </a>
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => handleNavClick(e, link.href)}
                      className="text-sm text-background-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-700/40 pt-8 mb-6">
          <h4 className="text-sm text-background-300 mb-4">合作伙伴</h4>
          <p className="text-sm text-background-600">合作伙伴信息持续更新中，敬请期待。</p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-6 border-t border-background-700/40">
          <p className="text-xs text-background-600">
            &copy; 2020-2026 51吃瓜最新网址 51chigua.com. All Rights Reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }} className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">回到顶部</a>
            <a href="#faq" onClick={(e) => handleNavClick(e, '#faq')} className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a>
            <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}